import { Component, Input } from '@angular/core';

import styles from './video-custom-fields.module.less';

interface ICustomField {
	name: string;
	value: string;
}

@Component({
	selector: 'video-custom-fields',
	templateUrl: './VideoCustomFields.Component.html'
})
export class VideoCustomFieldsComponent {
	@Input() public customFields: ICustomField[];

	public readonly styles = styles;
}
